import { Component, Input } from "@angular/core";
import { ORDER_TYPE_CONFIG } from "src/app/configs/order-type-config";
import { OrderDto } from "src/app/models/order-dto";
import { DatePipe } from "@angular/common";
import { BillOfMaterialsProgressPipe } from "../../../pipes/bill-of-materials-progress.pipe";

@Component({
    selector: "oaibox-order-details",
    templateUrl: "./order-details.component.html",
    styleUrl: "./order-details.component.css",
    imports: [DatePipe, BillOfMaterialsProgressPipe],
})
export class OrderDetailsComponent {
  @Input({ required: true }) order!: OrderDto;

  protected readonly ORDER_TYPE_CONFIG = ORDER_TYPE_CONFIG;
}
